// extracted by mini-css-extract-plugin
export default {"header":"header_header__lOwdN","header__head":"header_header__head__WbX42","header__title":"header_header__title__jxo3i"};